export interface SkeletonProps {
  shape: 'text' | 'row' | 'card';
  lines?: number;
  label?: string;
}

/**
 * Content shaped placeholders. There are no spinners in content areas; a spinner exists
 * only inside a button while an action runs.
 */
export function Skeleton({ shape, lines = 3, label = 'Loading' }: SkeletonProps) {
  const modifier = shape === 'text' ? '' : ` o-skeleton__bar--${shape}`;
  return (
    <div className="o-skeleton" role="status" aria-live="polite" aria-busy="true">
      <span className="o-visually-hidden">{label}</span>
      {Array.from({ length: lines }, (_, index) => (
        <span
          key={index}
          className={`o-skeleton__bar${modifier}`}
          style={{ width: `${100 - index * 8}%` }}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}
